"use client"; 

import { useState } from 'react'
import { FunnelIcon } from '@heroicons/react/20/solid'

import logger from '../../../lib/logger'
import CategoryApps from './categoryApps'
import CategoryFilters from './categoryFilters'
import SearchBar from '../navigation/searchBar';

export default function AppsDirectory({ apps=[], categories=[], category={} }) {
  logger.info("Component.AppsDirectory rendering.")

  if (!(categories?.length>0)) return <></>
  
  // Filter and Mobile Filter
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false)

  // Search App text 
  const [searchText, setSearchText] = useState('')

   
  return (
    <>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 ">
          <div className="lg:col-span-3">
            
            <div className="relative flex justify-between ">
            {/* relative z-10 flex items-baseline justify-between pt-24 pb-6 border-b border-gray-200 */}

              {/* <Link href='/apps'> */}
                <a href='/apps' className="block text-2xl sm:text-3xl font-extrabold tracking-tight text-gray-700 hover:text-crisp-700">
                  {category?.id ? (
                    <p className="py-2">Apps Directory</p>
                  ) : (
                    <h1 className="py-2">Apps Directory</h1>
                  )}
                </a>
              {/* </Link> */}

              <div className=" lg:hidden flex items-center">
                <button
                  type="button"
                  onClick={() => setMobileFiltersOpen(true)}
                  className="relative inline-flex items-center px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-crisp-500 focus:border-crisp-500"
                >
                  <FunnelIcon className="-ml-1 mr-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                  Filters
                </button>                
                {/* <button
                  type="button"
                  className="p-2 -m-2 ml-4 sm:ml-6 text-gray-400 hover:text-gray-500 lg:hidden"
                  onClick={() => setMobileFiltersOpen(true)}
                >
                  
                  <FunnelIcon className="w-5 h-5" aria-hidden="true" />
                  <span className="inline-flex">Filters</span>
                </button> */}
              </div>

            </div>


          </div>

          <div className="col-span-1 lg:col-span-9">
            {category?.id ? (
              <h1 className="py-2 text-2xl sm:text-3xl font-extrabold tracking-tight text-gray-700 truncate">
                Top {category?.name} apps
              </h1>
            ) : (
              <>
                <SearchBar 
                  searchText={searchText}
                  setSearchText={setSearchText}                  
                  placeholder='Search Apps'                   
                  showSearchButton={false}
                  showDropdownContainer={false}
                  classContainer='relative  '
                  classInput=" block w-full rounded-md py-3 pr-3 pl-9 text-base text-gray-900 placeholder-gray-400 shadow-sm border border-gray-300 outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500"              
                  // classInput='block w-full border border-transparent rounded-none rounded-l-md px-5 pr-3 pl-9 text-lg text-gray-900 placeholder-gray-400 shadow-sm outline-none focus:ring-1 focus:ring-amber-500 focus:border-amber-500' // with button
                  classDropdownContainer='z-10  mt-16 bg-white  shadow overflow-auto rounded-md  max-h-56 absolute inset-x-0 top-0 border-amber-500'
                />

                {/* <div className="relative text-gray-400 focus-within:text-gray-600">
                  <div className="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
                    <MagnifyingGlassIcon className="h-6 w-6" aria-hidden="true" />
                  </div>

                  <input
                    className="block w-full pl-11 py-3 text-base rounded-md placeholder-gray-500 shadow-sm focus:ring-crisp-500 focus:border-crisp-500 sm:flex-1 border-gray-300"
                    placeholder="Search Apps"
                    type="search"
                    name="search"
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />
                </div>  */}

              </>
               
            )}

          </div>

        </div> 

        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-9">
          <div className="lg:col-span-3">
            <CategoryFilters categories={categories} category={category} mobileFiltersOpen={mobileFiltersOpen} setMobileFiltersOpen={setMobileFiltersOpen} />
          </div>
          <div className="lg:col-span-9 ">
            <CategoryApps key={category?.slug} category={category} categories={categories} searchText={searchText} apps={apps} />
          </div>
        </div>          
      
      </div>
      
    </>
  )
}
